import { useLocalStorage, useSessionStorage } from "usehooks-ts";

type StorageType = "local" | "session";

export function usePersistedStorage<T>(key: string, initialValue: T, type: StorageType = "local") {
  // Call both hooks at the top level (hooks-ts handles the internal checks)
  const localRes = useLocalStorage<T>(key, initialValue);
  const sessionRes = useSessionStorage<T>(key, initialValue);

  // Explicitly pick the result based on the type
  const [value, setValue, removeValue] = type === "local" ? localRes : sessionRes;

  return [value, setValue, removeValue] as const;
}
